import { Component, computed, input } from '@angular/core';
import { Conversation } from '@vendasta/protos/meeting_analysis/v1';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'meeting-analysis-start-and-end',
  template: `{{ conversation()?.meetingDate | date: 'h:mm a' }} - {{ endTime() | date: 'h:mm a' }}`,
  imports: [DatePipe],
  standalone: true,
})
export class StartAndEndComponent {
  conversation = input<Conversation>();

  endTime = computed(() => {
    const conversation = this.conversation();
    if (!conversation?.duration || !conversation?.meetingDate) return conversation?.meetingDate;

    const durationInMs = Math.floor(parseFloat(conversation.duration) * 1000);
    const meetingStartDate = new Date(conversation.meetingDate);
    return new Date(meetingStartDate.getTime() + durationInMs);
  });
}
